import { defineStore } from "pinia";

interface Product {
  name: string;
  allowanceMb: number;
  retailPrice: number;
  validity: number;
}

export const useSimProductStore = defineStore("simProduct", {
  state: () => ({
    product: null as Product | null,
  }),
  actions: {
    setProduct(product: Product) {
      this.product = product;
    },
  },
});
